import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Feedback settings.
 *
 * Perechile vechi: `settings/easeedesk/feedback_settings`,
 * `feedback_settings_list`, `add_feedback_settings`, `change_feedback_status`,
 * `remove_feedback_setting`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface FeedbackRule {
  ID: number
  ticket_type: number
  type_name: string
  short_name: string
  color_identifier: string
  status: number
  status_name: string
  active: number
}

export interface FeedbackShell {
  title: string
  moduleUrl: string
  ticketTypes: { ID: number; type_name: string }[]
  statuses: { ID: number; status_name: string }[]
}

export function feedbackShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'feedback_settings'],
    queryFn: () => apiGet<FeedbackShell>('/settings/easeedesk/feedback_settings'),
  })
}

export function feedbackListQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'feedback_settings', 'list'],
    queryFn: () => apiGet<{ settings: FeedbackRule[] }>('/settings/easeedesk/feedback_settings/list'),
  })
}

/**
 * Starile tipului ales, din fluxul lui - perechea lui `get_ticket_type_status`,
 * pe care vechea fereastra o cerea la fiecare schimbare a tipului. `statuses`
 * din cap sunt starile implicite ale furnizorului, nu ale tipului.
 */
export function feedbackTypeStatusesQuery(type: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'feedback_settings', 'type_statuses', type],
    queryFn: () =>
      apiGet<{ statuses: { ID: number; status_name: string }[] }>(
        `/settings/easeedesk/feedback_settings/types/${type}/statuses`,
      ),
    enabled: type > 0,
  })
}

export function createFeedbackRule(ticket_type: number, status: number) {
  return apiPost<{ ok?: boolean; ID?: number }>('/settings/easeedesk/feedback_settings', {
    ticket_type,
    status,
  })
}

export function changeFeedbackRuleStatus(rule: number, on: boolean) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/feedback_settings/${rule}/status`, {
    active: on ? 'on' : 'off',
  })
}

export function removeFeedbackRule(rule: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/feedback_settings/${rule}/remove`, {})
}
